"use client";
import { Divider } from "@mui/material";
import React from "react";

export default function Specialize() {
  return (
    <div className="flex flex-col items-center">
      <div
        className="h-[853px] w-[1440px] relative"
        style={{ backgroundImage: "url('/icons/specialize/BG.png')" }}
      >
        <div className="h-[211px] relative flex justify-center">
          <img
            src="/icons/specialize/Group1.png"
            className="w-[555px] h-[78px] absolute top-[21px]"
            alt="logo"
          />

          <div className="text-center italic text-[#504F4F] text-[21px] top-[119px] absolute">
            <h2>
              We offer market insights, execution excellence, data-driven
              decisions,
            </h2>
            <h2>nationwide scalability, and deep expertise</h2>
          </div>
        </div>
        <div className="flex text-justify absolute bottom-[48px]">
          {/* Block 1 */}
          <div className="w-[358px] flex flex-col h-[600px] text-white pt-[36px] px-[38px] font-inter font-normal text-lg group relative overflow-hidden">
            {/* Background Layer */}
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-65 transform translate-y-[100%] group-hover:translate-y-0 transition-all duration-1000 ease-in-out"></div>

            {/* Text Content */}
            <h2 className="relative z-10 transform translate-y-[100%] group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-1000 ease-in-out">
              Through years of operating in Vietnam market and proprietary
              analysis we generate deep insights into target audience behaviour
              and industry trends. This allows us to develop uniquely tailored
              strategies for each client. Our deep industry knowledge enables us
              to anticipate changes and adapt strategies, ensuring our clients
              remain competitive
            </h2>
            <div className="symbol mt-auto mb-3 justify-end flex flex-col items-center relative z-10">
              <img src="/icons/specialize/Rectangle.png" alt="icon" />
              <h3 className="font-bold text-[25px]">Market</h3>
              <h3 className="font-bold text-[25px]">Insights</h3>
            </div>
          </div>

          <Divider
            style={{
              backgroundColor: "#9c9898",
              width: "1.5px",
              height: "593px",
            }}
            orientation="vertical"
            variant="middle"
          />

          {/* Block 2 */}
          <div className="w-[358px] h-[600px] flex flex-col text-white pt-[36px] px-[38px] font-inter font-normal text-lg group relative overflow-hidden">
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-65 transform translate-y-[100%] group-hover:translate-y-0 transition-all duration-1000 ease-in-out"></div>

            <h2 className="relative z-10 transform translate-y-[100%] group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-1000 ease-in-out">
              Leveraging Gold Standard project management techniques along with
              our strong human resources, proprietary workflows and reporting,
              we execute every initiative with flawless attention to detail.
              Clients are fully supported every step of the way.
            </h2>
            <div className="symbol mt-auto mb-3 flex flex-col items-center relative z-10">
              <img src="/icons/specialize/Rectangle1.png" alt="icon" />
              <h3 className="font-bold text-[25px]">Execution</h3>
              <h3 className="font-bold text-[25px]">Excellence</h3>
            </div>
          </div>

          <Divider
            style={{
              backgroundColor: "#9c9898",
              width: "1.5px",
              height: "593px",
            }}
            orientation="vertical"
            variant="middle"
          />

          {/* Block 3 */}
          <div className="w-[358px] h-[600px] flex flex-col text-white pt-[36px] px-[38px] font-inter font-normal text-lg group relative overflow-hidden">
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-65 transform translate-y-[100%] group-hover:translate-y-0 transition-all duration-1000 ease-in-out"></div>

            <h2 className="relative z-10 transform translate-y-[100%] group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-1000 ease-in-out">
              We leverage big data to enhance performance, optimize campaigns,
              and deliver measurable ROI. Our approach involves rigorous data
              analysis to pinpoint improvement opportunities and drive effective
              field marketing strategies. Using advanced technology, we provide
              efficient, data-backed solutions, ensuring that every action
              aligns with our clients strategic objectives.
            </h2>
            <div className="symbol mt-auto mb-3 justify-end flex flex-col items-center relative z-10">
              <img src="/icons/specialize/Rectangle2.png" alt="icon" />
              <h3 className="font-bold text-[25px]">Data-Driven</h3>
              <h3 className="font-bold text-[25px]">Decision Making</h3>
            </div>
          </div>

          <Divider
            style={{
              backgroundColor: "#9c9898",
              width: "1.5px",
              height: "593px",
            }}
            orientation="vertical"
            variant="middle"
          />

          {/* Block 4 */}
          <div className="w-[358px] h-[600px] flex flex-col text-white pt-[36px] px-[38px] font-inter font-normal text-lg group relative overflow-hidden">
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-65 transform translate-y-[100%] group-hover:translate-y-0 transition-all duration-1000 ease-in-out"></div>

            <h2 className="relative z-10 transform translate-y-[100%] group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-1000 ease-in-out">
              Our certified specialists have extensive experience in all
              available marketing channels and strategic HR solutions. Our team
              prioritizes continuous learning and development, making sure to
              stay up-to-date on industry trends and best practices to provide
              customized solutions that meet our clients specific needs.
            </h2>
            <div className="symbol mt-auto mb-3 justify-end flex flex-col items-center relative z-10">
              <img src="/icons/specialize/Rectangle3.png" alt="icon" />
              <h3 className="font-bold text-[25px]">Specialized</h3>
              <h3 className="font-bold text-[25px]">Expertise</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
